import { CenteredMessage } from './CenteredMessage';

interface ErrorMessageProps {
  title?: string;
  message: string;
}

/**
 * Displays an error message in a centered container with styled error box
 */
export function ErrorMessage({ title = 'Error', message }: ErrorMessageProps) {
  return (
    <CenteredMessage className="error-container">
      <div className="error-message">
        <h3>{title}</h3>
        <p>{message}</p>
      </div>
    </CenteredMessage>
  );
}